exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button.btn-primary[data-v-5a6433ec],button.btn-primary[data-v-5a6433ec]:hover{color:#fff;background-color:#0060d6;font-weight:500}div.run-connection-modal button.btn.close.close-modal[data-v-5a6433ec]{top:-40px;position:relative}div.run-connection-modal legend.close-modal[data-v-5a6433ec]{max-height:25px}div.run-connection-modal .modal-footer[data-v-5a6433ec]{padding:0}div.run-connection-modal .modal-footer>*[data-v-5a6433ec]{margin:0}#import-translations-modal .modal-dialog[data-v-5a6433ec]{position:relative}", ""]);

// exports
